import { WidgetStorageId } from '@/types/enums/WidgetStorageId';
import storage from 'local-storage-fallback';
import { useCallback } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

const useFetch = () => {
  const apiCall = useCallback(
    (
      path: string,
      method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' = 'GET',
      body: any = {},
      options: RequestInit = {}
    ) => {
      console.debug('useFetch', path, method, body);

      const hostId =
        storage.getItem(WidgetStorageId.HostId) ??
        window.TravelOneConfig.hostId;
      const widgetLanguage =
        storage.getItem(WidgetStorageId.WidgetLanguage) ?? 'en';
      const widgetCurrency =
        storage.getItem(WidgetStorageId.WidgetCurrency) ??
        storage.getItem(WidgetStorageId.WidgetPreferredCurrency) ??
        'EUR';

      return fetch(`${API_URL}${path}`, {
        ...options,
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'host-id': hostId,
          'Content-Language': widgetLanguage,
          'X-Currency': widgetCurrency,
          ...options.headers
        },
        body: method != 'GET' && body ? JSON.stringify(body) : undefined
      });
    },
    []
  );

  return apiCall;
};

export default useFetch;
